var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6014_12820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.45 11.2185L16.7827 0.56912C16.5493 0.399786 16.274 0.314453 15.9993 0.314453C15.7247 0.314453 15.45 0.39912 15.2167 0.568453L0.550667 11.2045C0.204667 11.4551 0 11.8565 0 12.2838V30.6671C0 31.4038 0.596667 32.0005 1.33333 32.0005H12H20H30.6667C31.4033 32.0005 32 31.4038 32 30.6671V12.2971C32 11.8705 31.7953 11.4691 31.45 11.2185ZM12 30.6671V21.3338H20V30.6671H12ZM30.6667 30.6671H21.3333V21.3338C21.3333 20.5971 20.7367 20.0005 20 20.0005H12C11.2633 20.0005 10.6667 20.5971 10.6667 21.3338V30.6671H1.33333V12.2838L15.9993 1.64779H16L30.6667 12.2971V30.6671Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6014_12820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.d1a835f3eff33b0a815291eeb73c5ad4.svg";
export { ForwardRef as ReactComponent };